export const WORK_SHIFTS_PATHS = {
  work_shifts: 'work_shifts',
};
